import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as service from "../service/StpTimeSheetApi"
import { useCallback, useEffect, useState } from "react";
import { setTimeSheetList, setIsLoading, setProject, setProjectList } from "../slices/TimeSheetSlice";
import { message } from "antd";
import { useTranslation } from "react-i18next";

function useSettingTimeSheetProject() {
    const { t } = useTranslation();
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [pagination, setPagination] = useState()
    const [isView, setIsView] = useState()
    const [isEdit, setIsEdit] = useState()
    const { isLoading, projectList } = useSelector((state) => state.timeSheet)
    const { currentCompany, currentEmployee } = useSelector((state) => state.company)

    const toParams = useCallback((params) => {
        const { pagination = {}, sortBy = [] } = params;
        const modifiedParams = {
            ...params,
            page: pagination.page || 0,
            size: pagination.pageSize || 10,
            sortBy: sortBy
                .filter((s) => s.order !== undefined)
                .map((s) => ({
                    direction: s.order === "descend" ? "desc" : "asc",
                    property: s.field,
                })),
        };
        return modifiedParams;

    }, [])

    const getStpTimeSheetPagination = useCallback(async (params) => {
        dispatch(setIsLoading(true))
        await service.getStpTimeSheetPagination({
            ...params,
            companyId: currentCompany,
            employeeId: currentEmployee
        }).then((response) => {
            dispatch(setProjectList(response?.data?.page?.content || []))
            setPagination({
                ...params?.pagination,
                current: response?.data?.page?.number + 1,
                pageNo: response?.data?.page?.number + 1,
                page: response?.data?.page?.number + 1,
                total: response.data?.page?.totalElements,
                size: response?.data?.page?.size
            });

        }).catch((error) => {
            message.error(t("common.error"))
        }).finally(() => {
            dispatch(setIsLoading(false))
        })
    }, [currentCompany, currentEmployee])

    const getStpTimeSheetById = useCallback(async (id) => {
        dispatch(setIsLoading(true))
        await service.getStpTimeSheetById({
            companyId: currentCompany,
            employeeId: currentEmployee,
            stpTimeSheetId: id
        }).then((response) => {
            dispatch(setProject(response?.data?.content))
        }).catch((error) => {
            message.error(t("common.error"))
        }).finally(() => {
            dispatch(setIsLoading(false))
        })
    }, [currentCompany, currentEmployee])

    const onPageChange = useCallback(
        (tablePagination, tableFilters, tableSorter, tableExtra) => {

            const modifiedSorter = Array.isArray(tableSorter)
                ? [...tableSorter]
                : [tableSorter];

            const modifiedParams = toParams({
                pagination: {
                    page: tablePagination?.current - 1,
                    size: tablePagination?.pageSize,
                    pageSize: tablePagination?.pageSize,
                    current: tablePagination.current - 1,
                },
                sortBy: modifiedSorter,
            });
            getStpTimeSheetPagination(modifiedParams);
        },
        [getStpTimeSheetPagination]
    );

    const updateTimeSheetStatus = useCallback(async (status, params) => {
        try {
            dispatch(setIsLoading(true))
            const response = await service.updateStpTimeSheetStatusFlag({
                companyId: currentCompany,
                employeeId: currentEmployee,
                stpTimeSheetId: params?.stpTimeSheetId,
                statusFlag: status ? "ACTIVE" : "INACTIVE"
            })
            message.success(t("common.success"))
        } catch (error) {
            message.error(t("common.error"))
        } finally {
            console.log("pagination ", pagination);
            getStpTimeSheetPagination({
                page: pagination?.page - 1,
                size: pagination?.pageSize || 10,
                pageSize: pagination?.pageSize || 10,
                current: pagination.current - 1,
            })
            dispatch(setIsLoading(false))

        }

    }, [currentCompany, currentEmployee, pagination, getStpTimeSheetPagination])

    const deleteStpTimeSheetById = useCallback(async (params) => {
        dispatch(setIsLoading(true))
        try {
            const response = await service.deleteStpTimeSheetById({
                companyId: currentCompany,
                employeeId: currentEmployee,
                stpTimeSheetId: params?.stpTimeSheetId,
            })
            message.success(t("common.success"))
        } catch (error) {
            message.error(t("common.error"))
        } finally {
            getStpTimeSheetPagination({
                page: pagination?.page - 1,
                size: pagination?.pageSize || 10,
                pageSize: pagination?.pageSize || 10,
                current: pagination.current - 1,
            })
            dispatch(setIsLoading(false))
        }

    }, [currentCompany, currentEmployee, pagination, getStpTimeSheetPagination])

    const onEdit = useCallback((record) => {
        setIsEdit(true)
        navigate(`/setting_timesheet/setting_project/edit/${record?.stpTimeSheetId}`)
    }, [])

    const onView = useCallback((record) => {
        setIsView(true)
        navigate(`/setting_timesheet/setting_project/view/${record?.stpTimeSheetId}`)
    }, [])

    useEffect(() => {
        console.log("isView in hook", isView);

    }, [isView])

    useEffect(() => {
        if (currentCompany) {
            getStpTimeSheetPagination({ page: 0, size: 10 })
        }
    }, [])

    return {
        getTimeSheetPagination: getStpTimeSheetPagination,
        isLoading,
        dataSource: projectList,
        pagination,
        onPageChange,
        updateTimeSheetStatus,
        onEdit,
        getStpTimeSheetById,
        deleteStpTimeSheetById,
        isView,
        onView,
        isEdit
    }
}

export default useSettingTimeSheetProject;